import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

const ErrorMessage = ({ centered, message, render }) => {
  if (message && render) {
    // prettier-ignore
    const parsedMessage = typeof message === 'object'
      ? Object.values(message).join(', ')
      : message

    return (
      <div
        className={classNames(
          'error-message',
          { 'justify-center': centered }
        )}
        title={parsedMessage}
        role="alert"
        aria-live="polite"
      >
        <svg
          className="w-4 h-4 flex-shrink-0 mt-0.5"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z"
            clipRule="evenodd"
          />
        </svg>
        <span>{parsedMessage}</span>
      </div>
    )
  }

  return null
}

ErrorMessage.propTypes = {
  centered: PropTypes.bool,
  message: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  render: PropTypes.bool,
}

export default ErrorMessage
